import { useState } from 'react';
import { Card, CardHeader, Link, Typography, Collapse, CardContent } from '@mui/material';
import { InfoAvatar } from './InfoAvatar';
import { Expander } from './Expander';
import PropTypes from 'prop-types';

export const CourseContentWrapper = ({ icon, title, titleAddOn, link, sxCardContent = {}, children }) => {
	const [expanded, setExpanded] = useState(true);
	const handleExpandClick = () => setExpanded(!expanded);
	const color = '#083163';

	const textStyle = {
		color: color,
		display: 'flex',
		'@container course-content (min-width: 0) and (max-width: 500px)': {
			fontSize: '1rem',
		},
		'@container course-content (min-width: 500px) and (max-width: 960px)': {
			fontSize: '1.375rem',
		},
		fontSize: '1.667rem',
		fontWeight: 'medium',
		lineHeight: 1,
	};

	const hasContent = !!children;

	const contentTitle = (() => {
		if (link) {
			return (
				<Link
					sx={{
						color: color,
						display: 'flex',
						flexDirection: 'row',
						textDecoration: 'none',
						'@container course-content (min-width: 0) and (max-width: 650px)': {
							flexDirection: 'column',
						},
						'&:hover': {
							color: color,
							textDecoration: `underline ${color}`,
						},
					}}
					href={link}
					target='_blank'
				>
					{title}
					{titleAddOn && <Typography component='span'
						sx={{
							alignSelf: 'end',
							paddingLeft: '.5rem',
							'@container course-content (min-width: 0) and (max-width: 650px)': {
								fontSize: '.75rem',
								paddingLeft: 0,
							},
							'@container course-content (min-width: 0) and (max-width: 421px)': {
								display: 'none',
							},
							'@container course-content (min-width: 960px)': {
								lineHeight: 1.25,
							},
						}}>{titleAddOn}</Typography>}
				</Link>
			);
		}
		return title;
	})();

	return (
		<Card
			sx={{
				container: 'course-content / inline-size',
				display: 'flex',
				flexDirection: 'column',
				borderRadius: '10px',
				boxShadow: 2,
				marginTop: '1rem',
				maxWidth: '100%',
				overflow: 'visible',
			}}
		>
			<CardHeader
				sx={{
					alignItems: 'center',
					backgroundColor: hasContent && expanded ? '#FBFCEA' : '#FFFFFF',
					height: '55px',
					padding: 0,
					'@container course-content (min-width: 0) and (max-width: 500px)': {
						height: '45px',
					},
				}}
				avatar={<InfoAvatar identifier={icon} />}
				title={<Typography sx={textStyle}>{contentTitle}</Typography>}
				action={hasContent ?
					<Expander expanded={expanded} onClick={handleExpandClick} color={color} /> : undefined}
			/>
			{hasContent && <Collapse in={expanded}>
				<CardContent sx={sxCardContent}>
					{children}
				</CardContent>
			</Collapse>}
		</Card>
	);
};

CourseContentWrapper.propTypes = {
	icon: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	titleAddOn: PropTypes.string,
	link: PropTypes.string,
	children: PropTypes.node,
};